import type { QueryKey } from '@tanstack/react-query';

import useQuery from '../../../../ReactQuery/useQuery';
import { get } from '../../../../redux/api';

export type OrganizationPlanUsage = {
  projectCount: number;
  recentRevisionCount: number;
  solvedIssueCount: number;
};

function fetchPlanUsage() {
  return get<OrganizationPlanUsage>(`/api/organizations/subscription/usage`);
}

const getQueryKey = (): QueryKey => ['organization-plan-usage'];

/**
 * Fetches the current organization plan usage.
 */
export default function usePlans() {
  return useQuery<OrganizationPlanUsage>({
    queryKey: getQueryKey(),
    queryFn: () => fetchPlanUsage(),
  });
}
